export const DEVELOPER_MODE = 'ALLOX_DEVELOPER';
export const ALLOX_PREFIX = 'allox_';
export const ALLOX_ROLE_KEY = 'alloxRole';

// API - Responseのステータスコード
export enum AlloxApiStatus {
  SUCCESS = 'A200',
  BAD_REQUEST = 'A400',
  INVALID_SESSION = 'A401',
  NOT_FOUND = 'A404',
  CONFLICT = 'A409',
  INTERNAL_SERVER_ERROR = 'A500',
  SERVICE_UNAVAILABLE = 'A503',
}

// API - Responseのエラーコード
export enum AlloxApiErrorCode {
  // 認証画面でのセッション有効期限切れ
  AUTH_SESSION_EXPIRED = 63,
  // メンテナンス実施中
  MAINTENANCE_MODE= 68,
}

// DeliverySet - 配信ステータス
export enum DeliverySetStatus {
  ENABLE = 1,
  PAUSE = 2,
}
export const DeliverySetStatusLabels = {
  [DeliverySetStatus.ENABLE]: '有効',
  [DeliverySetStatus.PAUSE]: '一時停止',
};

export enum DeliverySetStatusSearchIndex {
  PAUSE = 0,
  ENABLE = 1,
}
export const DeliverySetStatusSearchLabels = {
  [DeliverySetStatusSearchIndex.PAUSE]: '一時停止',
  [DeliverySetStatusSearchIndex.ENABLE]: '有効',
};

// NOTE: 画面の表示順からDBのコード値にコンバートする定数Map
export const DeliverySetStatusSearchConvertFromScreenDisplayOrderToDBCode = {
  [DeliverySetStatusSearchIndex.PAUSE]: DeliverySetStatus.PAUSE,
  [DeliverySetStatusSearchIndex.ENABLE]: DeliverySetStatus.ENABLE,
};

// NOTE: DBのコード値から画面の表示順にコンバートする定数Map
export const DeliverySetSearchStatusConvertFromDBCodeToScreenDisplayOrder = {
  [DeliverySetStatus.PAUSE]: DeliverySetStatusSearchIndex.PAUSE,
  [DeliverySetStatus.ENABLE]: DeliverySetStatusSearchIndex.ENABLE,
};

// DeliverySet - 配信状態
export enum DeliverySetCondition {
  BEFORE = 0,
  DURING = 1,
  END = 2,
}
export const DeliverySetConditionLabels = {
  [DeliverySetCondition.BEFORE]: '期間前',
  [DeliverySetCondition.DURING]: '期間中',
  [DeliverySetCondition.END]: '期間終了',
};

// DeliverySet - 配信状態
export enum DeliverySetConditionSearchIndex {
  BEFORE = 0,
  DURING = 1,
  END = 2,
}
export const DeliverySetConditionSearchLabels = {
  [DeliverySetCondition.BEFORE]: '期間前',
  [DeliverySetCondition.DURING]: '期間中',
  [DeliverySetCondition.END]: '期間終了',
};

export const DeliverySetConditionSearchConvert = {
  [DeliverySetConditionSearchIndex.BEFORE]: DeliverySetCondition.BEFORE,
  [DeliverySetConditionSearchIndex.DURING]: DeliverySetCondition.DURING,
  [DeliverySetConditionSearchIndex.END]: DeliverySetCondition.END,
};

// DeliverySet - LP遷移先
export enum DeliverySetLpOpenMethod {
  NOT_SDK = 0,
  BROWSER = 1,
  WEBVIEW = 2,
}
export const DeliverySetLpOpenMethodLabels = {
  [DeliverySetLpOpenMethod.NOT_SDK]: '',
  [DeliverySetLpOpenMethod.BROWSER]: 'ブラウザ',
  [DeliverySetLpOpenMethod.WEBVIEW]: 'WebView',
};

// DeliverySet - 配信コントロールタイプ
export enum DeliveryControlType {
  NETWORK_PASSBACK = 1,
  BIDDING = 2,
}
export const DeliveryControlTypeLabels = {
  [DeliveryControlType.NETWORK_PASSBACK]: 'Network/PassBack',
  [DeliveryControlType.BIDDING]: 'Bidding',
};

// Platform - Passback行のID
export const PLATFORM_PASSBACK_ID = 8;

/**
 * 配信コントロールの書き出し方法
 *
 * @enum {number}
 * @property {number} INLINE - 1
 * @property {number} IFRAME - 2
 */
export enum DeliveryControlDrawMethod {
  INLINE = 1,
  IFRAME = 2,
}
/**
 * 配信コントロールの書き出し方法のラベル
 *
 * @see DeliveryControlDrawMethod
 */
export const DeliveryControlDrawMethodLabels = {
  [DeliveryControlDrawMethod.INLINE]: 'in-line',
  [DeliveryControlDrawMethod.IFRAME]: 'iframe',
};
/**
 * 配信コントロールの書き出し方法フラグ
 *
 * @enum {number}
 * @property {number} ALL - 1
 * @property {number} INLINE_ONLY - 2
 * @property {number} IFRAME_ONLY - 3
 */
export enum DeliveryControlDrawMethodFlag {
  ALL = 1,
  INLINE_ONLY = 2,
  IFRAME_ONLY = 3,
}

export enum PlatformDeliveryType {
  HEADER_BIDDING = 1,
  RTB = 2,
  NETWORK = 3,
  PASS_BACK = 4,
  SDK = 5,
  OUTER_BIDDING = 6,
}
export const PlatformDeliveryTypeLabels = {
  [PlatformDeliveryType.HEADER_BIDDING]: 'Header Bidding',
  [PlatformDeliveryType.RTB]: 'Server Bidding',
  [PlatformDeliveryType.OUTER_BIDDING]: 'Outer Bidding',
};

export enum CheckBoxPlatformDeliverType {
  HEADER_BIDDING = 1,
  RTB = 2,
  NETWORK_PASSBACK = 3,
  OUTER_BIDDING = 4
}

// プラットフォームのkey発行状態フラグ
export enum PlatformHasEncryptKeyFlag {
  HAS_ENCRYPT_KEY = 0,
}

// 配信面(広告リクエストパラメータテンプレート)
export enum DeliveryScope {
  WEB = 1,
  APP = 2,
  BOTH = 3,
}

// 配信面ラベル(広告リクエストパラメータテンプレート)
export const DeliveryScopeLabels = {
  [DeliveryScope.WEB]: 'Web',
  [DeliveryScope.APP]: 'App',
  [DeliveryScope.BOTH]: '両方',
};

/**
 * 配信面/配信方法
 *
 * @enum {number}
 * @property {number} WEB - 0
 * @property {number} APP_S2S - 1
 * @property {number} APP_SDK - 2
 * @property {number} ALL - 999
 */
export enum MediaType {
  WEB = 0,
  APP_S2S = 1,
  APP_SDK = 2,
  ALL = 999,
}

/**
 * 配信面のラベル
 *
 * @see MediaType
 */
export const MediaTypeLabels = {
  [MediaType.WEB]: 'Web',
  [MediaType.APP_S2S]: 'App',
  [MediaType.APP_SDK]: 'App',
};

/**
 * 配信方法のラベル
 *
 * @see MediaType
 */
export const MediaTypeAppLabels = {
  [MediaType.APP_S2S]: 'S2S',
  [MediaType.APP_SDK]: 'SDK',
};

export enum MediaTypeSearchIndex {
  WEB = 0,
  APP_S2S = 1,
  APP_SDK = 2,
}

export const MediaTypeSearchLabels = {
  [MediaTypeSearchIndex.WEB]: 'Web',
  [MediaTypeSearchIndex.APP_S2S]: 'App S2S',
  [MediaTypeSearchIndex.APP_SDK]: 'App SDK',
};

export const MediaTypeSearchConvert = {
  [MediaTypeSearchIndex.WEB]: MediaType.WEB,
  [MediaTypeSearchIndex.APP_S2S]: MediaType.APP_S2S,
  [MediaTypeSearchIndex.APP_SDK]: MediaType.APP_SDK,
};

/**
 * 広告フォーマットタイプ
 *
 * @enum {number}
 * @property {number} PASSBACK - 0
 * @property {number} NATIVE - 1
 * @property {number} BANNER - 2
 * @property {number} VIDEO - 3
 * @property {number} NATIVE_TO_BANNER - 4（SDKのみ設定可）
 */
export enum AdFormatType {
  PASSBACK = 0,
  NATIVE = 1,
  BANNER = 2,
  VIDEO = 3,
  NATIVE_TO_BANNER = 4,
}
/**
 * 広告フォーマットタイプのラベル
 *
 * @see AdFormatType
 */
export const AdFormatTypeLabels = {
  [AdFormatType.PASSBACK]: 'パスバック',
  [AdFormatType.NATIVE]: 'ネイティブ',
  [AdFormatType.BANNER]: 'バナー',
  [AdFormatType.VIDEO]: '動画',
  [AdFormatType.NATIVE_TO_BANNER]: 'ネイティブtoバナー',
};

// デザインテンプレート検索タイプ
export enum DesignTemplateSearchType {
  ALL = 0,
  NORMAL = 1,
  STANDARD = 2,
}

export const DesignTemplateSearchTypeLabels = {
  [DesignTemplateSearchType.NORMAL]: 'normal',
  [DesignTemplateSearchType.STANDARD]: 'standard',
};

// キャリアの定義
export enum Carrier {
  BROWSER,
  DOCOMO,
  AU,
  SOFTBANK,
  OTHER,
}
export const CarrierLabels = {
  [Carrier.BROWSER]: 'ブラウザ',
  [Carrier.DOCOMO]: 'docomo',
  [Carrier.AU]: 'au',
  [Carrier.SOFTBANK]: 'SoftBank',
  [Carrier.OTHER]: 'その他キャリア',
};

// フロアプライス最適化チェック
export enum FloorPriceOptimize {
  OFF = 0,
  ON = 1,
}

// フロアプライス最適化設定状況
export const FloorPriceOptimizeLabels = {
  [FloorPriceOptimize.ON]: '設定あり',
  [FloorPriceOptimize.OFF]: '設定なし',
};

// 配信比率自動化チェック
export enum EnableAutomaticRatio {
  ON = 1,
  OFF = 2,
}

// デザインテンプレートタイプ
export enum DesignTemplateType {
  WEB = 1,
  APP_SDK = 2,
}

export const DesignTemplateTypeLabels = {
  [DesignTemplateType.WEB]: 'Web',
  [DesignTemplateType.APP_SDK]: 'App SDK',
};

// デザインテンプレート 動画パーツタイプ
export enum DesignTemplateAssetType {
  VOLUME_ON = 1,
  VOLUME_OFF = 2,
  PLAY_VIDEO = 3,
  STOP_VIDEO = 4,
  LINK_CTA = 5,
  LINK_COMPLETE = 6,
  REPEAT_VIDEO = 7,
  SEEKBAR_COLOR = 8,
}

export const DesignTemplateAssetTypeLabels = {
  [DesignTemplateAssetType.VOLUME_ON]: '音量ON',
  [DesignTemplateAssetType.VOLUME_OFF]: '音量OFF',
  [DesignTemplateAssetType.PLAY_VIDEO]: '再生',
  [DesignTemplateAssetType.STOP_VIDEO]: '停止',
  [DesignTemplateAssetType.LINK_CTA]: '詳しくはこちら',
  [DesignTemplateAssetType.LINK_COMPLETE]: '詳しくはこちら（再生終了）',
  [DesignTemplateAssetType.REPEAT_VIDEO]: 'リプレイ',
  [DesignTemplateAssetType.SEEKBAR_COLOR]: 'シークバー色',
};

// OSグループ設定
export enum OSGroupSetting {
  OFF = 1,
  ON = 2,
}

// SDKバージョングループ設定
export enum SDKVersionGroupSetting {
  OFF = 1,
  ON = 2,
}

// デザインテンプレートをモーダルでプレビューする際に使う置換マップ
export const DesignTemplatePreviewModalReplaces = [
  { regexp: /{#frame_id}/g, value: 'FRAME_ID' },
  { regexp: /{#func_name}/g, value: 'FUNC_NAME' },
  {
    regexp: /{#title}/g,
    value: 'タイトルあいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほ',
  },
  {
    regexp: /{#advertiser}/g,
    value: '広告主名あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほ',
  },
  { regexp: /{#image}/g, value: 'https://dmview.d2c.ne.jp/alxmng/img/allox_preview.jpg' },
  { regexp: /{#imgurl}/g, value: 'https://dmview.d2c.ne.jp/alxmng/img/allox_preview_2.jpg' },
  {
    regexp: /{#image_oblong}/g,
    value: 'https://dmview.d2c.ne.jp/alxmng/img/allox_preview_oblong.jpg',
  },
  {
    regexp: /{#caption}/g,
    value: '広告詳細文あいうえおかきくけこさしすせそたちつてとなにぬねのはひふへほ',
  },
  { regexp: /{#lpurl}/g, value: 'https://www.d2c.co.jp/' },
  { regexp: /{#optout_clickurl}/g, value: 'https://smt.docomo.ne.jp/portal/src/terms_ad3.html' },
  { regexp: /{#optout_image}/g, value: 'https://dmview.d2c.ne.jp/alxmng/img/allox_optout.png' },
  { regexp: /{#cta}/g, value: 'CTAあいうえおかきくけこさしすせそ' },
  {
    regexp: /{#html}/g,
    value: `<style>
    .banner-wrapper {
      text-align:center;
      margin:auto;
      line-height: 0;
      font-size: 0;
    }
    .main_image{
      width: 300px;
      height: 250px;
    }
    </style>
    <div class="banner-wrapper">
      <a href="https://www.d2c.co.jp/">
        <img class="main_image" src="https://dmview.d2c.ne.jp/alxmng/img/allox_preview_banner.png">
      </a>
    </div>`,
  },
  {
    regexp: /{#video}/g,
    value: `<div style="width:320px;height:180px;overflow:hidden; margin: auto; text-align: center;">
      <video
      src="https://dmview.d2c.ne.jp/alxmng/video/allox_preview_video.mp4"
      autoplay=""
      playsinline=""
      disablepictureinpicture=""
      disableremoteplayback=""
      style="display: block; width: 100%; height: 100%;"></video>
    </div>`,
  },
  { regexp: /{#random_1}/g, value: 'random_1' },
  { regexp: /{#random_2}/g, value: 'random_2' },
  { regexp: /{#random_3}/g, value: 'random_3' },
  { regexp: /{#random_4}/g, value: 'random_4' },
  { regexp: /{#random_5}/g, value: 'random_5' },
];

// デバッグモード
export enum DebugMode {
  OFF = 0,
  ON = 1,
  ON_REQUEST_RESPONE_INFO = 2,
}

// プレースメント追加情報設定
export enum PlacementAssetType {
  TAP_ACTION = 9,
  DISPLAY_PLACE = 10,
  PLAYER_SIZE = 11,
  READ_POSITION = 12,
  MARGIN = 13,
  HEADER_COLOR = 14,
  HEADER_TEXT = 15,
  HEADER_TEXT_COLOR = 16,
  FLOATING_PLAYER_SEEKBAR_COLOR = 17,
  CLOSEBUTTON_IMAGE_URL = 18,
  Z_INDEX = 19,
}

export const PlacementAssetTypeLabels = {
  [PlacementAssetType.TAP_ACTION]: 'タップ動作',
  [PlacementAssetType.DISPLAY_PLACE]: '表示位置',
  [PlacementAssetType.PLAYER_SIZE]: 'プレイヤーサイズ（%）',
  [PlacementAssetType.READ_POSITION]: '読込み開始位置（pt）',
  [PlacementAssetType.MARGIN]: 'マージン（pt）',
  [PlacementAssetType.HEADER_COLOR]: 'ヘッダー色',
  [PlacementAssetType.HEADER_TEXT]: 'ヘッダーテキスト',
  [PlacementAssetType.HEADER_TEXT_COLOR]: 'ヘッダーテキスト色',
  [PlacementAssetType.FLOATING_PLAYER_SEEKBAR_COLOR]: 'シークバー色',
  [PlacementAssetType.CLOSEBUTTON_IMAGE_URL]: 'クローズボタンURL',
  [PlacementAssetType.Z_INDEX]: 'z-index',
};

// プレースメント追加情報 タップ動作
export enum PlacementAssetTapType {
  EXPAND = 1,
  LP_TRANSITION = 2,
}

export const PlacementAssetTapTypeLabels = {
  [PlacementAssetTapType.EXPAND]: 'エキスパンド',
  [PlacementAssetTapType.LP_TRANSITION]: 'LP遷移',
};

// プレースメント追加情報 表示位置
export enum PlacementAssetDisplayType {
  UPPER_RIGHT = 1,
  LOWER_RIGHT = 2,
  UPPER_LEFT = 3,
  LOWER_LEFT = 4,
}

export const PlacementAssetDisplayTypeLabels = {
  [PlacementAssetDisplayType.UPPER_RIGHT]: '右上',
  [PlacementAssetDisplayType.LOWER_RIGHT]: '右下',
  [PlacementAssetDisplayType.UPPER_LEFT]: '左上',
  [PlacementAssetDisplayType.LOWER_LEFT]: '左下',
};

export enum PlacementHasAsset {
  HAS_ASSET = '設定済み',
  NOT_HAS_ASSET = '未設定',
}

// ユーザ権限
export enum UserRoleCondition {
  SYSTEM_ADMIN = 1,
  MEDIA_HANDLER = 2,
  OPERATION_ADMIN = 3,
  SYSTEM_OPERATOR = 4,
  SYSTEM_HANDLER = 5,
}

// 関係者配信
export enum DeliverySetTesterCondition {
  OFF = 0,
  ON = 1,
}

// 関係者配信ラベル用
export const DeliverySetTesterConditionLabels = {
  [DeliverySetTesterCondition.ON]: 'あり',
  [DeliverySetTesterCondition.OFF]: 'なし'

};

export const UserRoleConditionLabels = {
  [UserRoleCondition.SYSTEM_ADMIN]: 'システム管理者',
  [UserRoleCondition.MEDIA_HANDLER]: '媒体担当者',
  [UserRoleCondition.OPERATION_ADMIN]: '運用管理者',
  [UserRoleCondition.SYSTEM_OPERATOR]: 'システム運用者',
  [UserRoleCondition.SYSTEM_HANDLER]: 'システム担当者',
};

// ユーザステータス
export enum UserStatusCondition {
  USER_STATUS_NO_SETUP = 1,
  USER_STATUS_MFA_DEVICE_REGISTERED = 2,
  USER_STATUS_COMPLETED = 3,
}
export const UserStatusConditionLabels = {
  [UserStatusCondition.USER_STATUS_NO_SETUP]: 'セットアップ未実施',
  [UserStatusCondition.USER_STATUS_MFA_DEVICE_REGISTERED]: 'MFAデバイス登録済み',
  [UserStatusCondition.USER_STATUS_COMPLETED]: 'セットアップ完了',
};

// アクセス権限
export enum AccessPermission {
  CREATE = 'C',
  UPDATE = 'U',
  READ = 'R',
  DELETE = 'D',
  EXECUTE = 'X',
}

// URLパス
export enum UrlPath {
  NEW = 'new',
  COPY = 'copy',
  EDIT = 'edit',
}

// コンテンツ名
export enum Contents {
  DELIVERY_SET = 'delivery_sets',
  DESIGN_TEMPLATE = 'design_templates',
  STANDARD_DESIGN_TEMPLATE = 'standard_design_templates',
  PLACEMENT_RELATION = 'placement_relations',
  AD_REQUEST = 'ad_requests',
  PLACEMENT = 'placements',
  TESTER_DEVICE = 'tester_devices',
  DEVICE_MODEL = 'device_models',
  DEVICE_MODEL_GROUP = 'device_model_groups',
  OPERATING_SYSTEM = 'operating_systems',
  OS_GROUP = 'os_groups',
  PLATFORM_OS_GROUP = 'platform_os_groups',
  SDK_VERSION = 'sdk_versions',
  SDK_VERSION_GROUP = 'sdk_version_groups',
  PLATFORM_SDK_VERSION_GROUP = 'platform_sdk_version_groups',
  DEAL = 'deals',
  EXCHANGE_RATE = 'exchange_rates',
  EMERGENCY_STOP = 'emergency_stop',
  PLATFORMS_KEYS = 'platforms/keys',
  TOPICS_URL = 'topics_urls',
  MULTI_AD_CONFIGS = 'multi_ad_configs',
  AD_REQUEST_PARAMETER_TEMPLATE = 'ad_request_parameter_templates',
  USERS = 'users',
  PLATFORM_RESERVATION = 'platform_reservations',
  MAINTENANCE = 'maintenance',
}

// Placement検索モード
export enum PlacementSearchMode {
  LINK = 'link',
}

// ユーザステータス
export enum UserStatus {
  // セットアップ未実施
  USER_STATUS_NO_SETUP = 1,
  // MFAデバイス登録済み
  USER_STATUS_MFA_DEVICE_REGISTERED = 2,
  // セットアップ完了
  USER_STATUS_COMPLETED = 3,
}

// 次アクション(認証系)
export enum NextAction {
  // ユーザ名/パスワード認証
  AUTH_PW = 'AUTH_PW',
  // MFAデバイス登録
  REGISTER_MFA_DEVICE = 'REGISTER_MFA_DEVICE',
  // MFAコードの認証
  AUTH_MFA = 'AUTH_MFA',
  // パスワード変更
  CHANGE_PW = 'CHANGE_PW',
  // ログイン成功
  LOGIN_SUCCESS = 'LOGIN_SUCCESS',
}


/**
 * サイトのTypeを表すEnum.
 *
 * @enum {string}
 * @property {string} WEB - Web
 * @property {string} APP - App
 */
export enum SiteType {
  WEB = '1',
  APP = '2',
}

// メンテナンス状態
export enum MaintenanceStatus {
  OPERATIONAL = 1,
  MAINTENANCE = 2,
}
export const MaintenanceStatusLabels = {
  [MaintenanceStatus.OPERATIONAL]: '通常稼動中',
  [MaintenanceStatus.MAINTENANCE]: 'メンテナンス中',
};

// プレースメント検索時のプレースメント追加設定指定用
export enum FloatingSettingSearchType {
  // プレースメント追加設定未指定
  NOT_SPECIFIED = 0,
  // プレースメント追加設定設定なし
  NOT_SET = 1,
  // プレースメント追加設定設定済み
  IS_SET = 2,
}

/**
 * 配信PF予約登録の処理ステータス
 *
 * @enum {number}
 * @property {number} PENDING - 1: 未処理
 * @property {number} IN_PROGRESS - 2: 処理中
 * @property {number} SUCCESS - 3: 成功
 * @property {number} FAILURE - 4: 失敗
 */
export enum PlatformReservationStatus {
  PENDING = 1,
  IN_PROGRESS = 2,
  SUCCESS = 3,
  FAILURE = 4,
}
/**
 * 配信PF予約登録の処理ステータスのラベル
 *
 * @see PlatformReservationStatus
 */
export const PlatformReservationStatusLabels = {
  [PlatformReservationStatus.PENDING]: '未処理',
  [PlatformReservationStatus.IN_PROGRESS]: '処理中',
  [PlatformReservationStatus.SUCCESS]: '成功',
  [PlatformReservationStatus.FAILURE]: '失敗',
};
